<template>
  <div>
    <div v-if="reportCustomComponentRelManageInfo.curComponent !== 'addReportCustomComponentRel'">
      <el-row>
        <el-col :span="24">
          <el-card>
            <div slot="header" class="flex justify-between">
              <h5>{{reportCustomComponentRelManageInfo.title}}<span>{{$t('reportCustomComponentRel.component')}}</span></h5>
              <div>
                <el-button size="small" @click="_goBack()">
                  {{$t('reportCustomComponentRel.back')}}
                </el-button>
                <el-button type="primary" size="small" @click="_openAddReportCustomComponentRelModal()">
                  <i class="el-icon-plus"></i>
                  {{$t('reportCustomComponentRel.associateComponent')}}
                </el-button>
              </div>
            </div>
            <div class="card-body">
              <el-table
                :data="reportCustomComponentRelManageInfo.reportCustomComponentRels"
                style="width: 100%"
                border>
                <el-table-column
                  prop="relId"
                  :label="$t('reportCustomComponentRel.relId')"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="componentName"
                  :label="$t('reportCustomComponentRel.component')"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="customId"
                  :label="$t('reportCustomComponentRel.reportId')"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="seq"
                  :label="$t('reportCustomComponentRel.componentSeq')"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  :label="$t('reportCustomComponentRel.associateTime')"
                  align="center">
                </el-table-column>
                <el-table-column
                  :label="$t('reportCustomComponentRel.operation')"
                  align="center">
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-button
                        size="mini"
                        @click="_openDeleteReportCustomComponentRelModel(scope.row)">
                        {{$t('reportCustomComponentRel.delete')}}
                      </el-button>
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="reportCustomComponentRelManageInfo.conditions.page"
                :page-size="reportCustomComponentRelManageInfo.conditions.row"
                layout="total, prev, pager, next"
                :total="reportCustomComponentRelManageInfo.total">
              </el-pagination>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div v-else>
      <add-report-custom-component-rel ref="addReportCustomComponentRel"></add-report-custom-component-rel>
    </div>
    <delete-report-custom-component-rel ref="deleteReportCustomComponentRel"></delete-report-custom-component-rel>
  </div>
</template>

<script>
import { listReportCustomComponentRel } from '@/api/dev/reportCustomComponentRelApi'
import AddReportCustomComponentRel from '@/components/dev/addReportCustomComponentRel/addReportCustomComponentRel'
import DeleteReportCustomComponentRel from '@/components/dev/deleteReportCustomComponentRel/deleteReportCustomComponentRel'

export default {
  name: 'ReportCustomComponentRelManage',
  components: {
    AddReportCustomComponentRel,
    DeleteReportCustomComponentRel
  },
  data() {
    return {
      reportCustomComponentRelManageInfo: {
        reportCustomComponentRels: [],
        total: 0,
        records: 1,
        moreCondition: false,
        curComponent: 'reportCustomComponentRel',
        relId: '',
        title: '',
        conditions: {
          page: 1,
          row: 10,
          relId: '',
          customId: ''
        }
      }
    }
  },
  created() {
    this.reportCustomComponentRelManageInfo.conditions.customId = this.$route.query.customId
    this.reportCustomComponentRelManageInfo.title = this.$route.query.title
    this._listReportCustomComponentRels(1, 10)
  },
  methods: {
    handleCurrentChange(val) {
      this._listReportCustomComponentRels(val, this.reportCustomComponentRelManageInfo.conditions.row)
    },
    async _listReportCustomComponentRels(page, rows) {
      this.reportCustomComponentRelManageInfo.conditions.page = page
      this.reportCustomComponentRelManageInfo.conditions.row = rows
      try {
        const res = await listReportCustomComponentRel(this.reportCustomComponentRelManageInfo.conditions)
        this.reportCustomComponentRelManageInfo.total = res.total
        this.reportCustomComponentRelManageInfo.records = res.records
        this.reportCustomComponentRelManageInfo.reportCustomComponentRels = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    _openAddReportCustomComponentRelModal() {
      this.reportCustomComponentRelManageInfo.curComponent = 'addReportCustomComponentRel'
      this.$refs.addReportCustomComponentRel.open({
        customId: this.reportCustomComponentRelManageInfo.conditions.customId
      })
    },
    _openDeleteReportCustomComponentRelModel(row) {
      this.$refs.deleteReportCustomComponentRel.open(row)
    },
    _goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.card-body {
  padding: 20px;
}
</style>